<template>
    <div class="signature-settings">
        <div class="settings-group">
            <label class="settings-label">
                Alan Etiketi
                <span class="settings-label-required">*</span>
            </label>
            <input
                type="text"
                v-model="localFieldLabel"
                @input="updateField"
                class="settings-input"
                placeholder="İmza"
                ref="fieldLabelInput"
            />
        </div>

        <div class="settings-group">
            <label class="settings-label">Hizalama</label>
            <select
                v-model="localAlign"
                @change="updateField"
                class="settings-select"
            >
                <option value="top">Üst</option>
                <option value="left">Sol</option>
                <option value="center">Merkez</option>
                <option value="right">Sağ</option>
            </select>
        </div>

        <div class="settings-group">
            <label class="settings-label">Alt Etiket</label>
            <input
                type="text"
                v-model="localAltLabel"
                @input="updateField"
                class="settings-input"
                placeholder="Lütfen imzanızı çiziniz"
                ref="altLabelInput"
            />
        </div>

        <div class="settings-group">
            <div class="settings-checkbox-group">
                <input
                    type="checkbox"
                    id="signature-required"
                    v-model="localIsRequired"
                    @change="updateField"
                    class="settings-checkbox"
                />
                <label for="signature-required" class="settings-checkbox-label">
                    Zorunlu alan
                </label>
            </div>
        </div>

        <div class="settings-group">
            <label class="settings-label">Görünürlük</label>
            <div class="settings-checkbox-group">
                <input
                    type="checkbox"
                    id="signature-visibility"
                    v-model="localVisibility"
                    @change="updateField"
                    class="settings-checkbox"
                />
                <label for="signature-visibility" class="settings-checkbox-label">
                    Alan görünür
                </label>
            </div>
        </div>

        <div class="settings-group">
            <label for="slug-input" class="settings-label">URL Parametresi</label>
            <input
                type="text"
                id="slug-input"
                v-model="localSlug"
                @input="setSlug($event.target.value)"
                class="settings-input"
                placeholder="signature"
                ref="slugInput"
            />
            <small class="settings-help">URL parametrelerinde kullanılacak benzersiz tanımlayıcı</small>
        </div>

        <div class="settings-section">
            <h4 class="settings-section-title">Canvas Boyutları</h4>

            <div class="settings-row">
                <div class="settings-group">
                    <label class="settings-label">Genişlik (px)</label>
                    <input
                        type="number"
                        v-model.number="localCanvasWidth"
                        @input="updateField"
                        class="settings-input"
                        min="200"
                        max="800"
                        placeholder="400"
                    />
                </div>

                <div class="settings-group">
                    <label class="settings-label">Yükseklik (px)</label>
                    <input
                        type="number"
                        v-model.number="localCanvasHeight"
                        @input="updateField"
                        class="settings-input"
                        min="100"
                        max="400"
                        placeholder="200"
                    />
                </div>
            </div>
        </div>

        <div class="settings-section">
            <h4 class="settings-section-title">Çizim Ayarları</h4>

            <div class="settings-group">
                <label class="settings-label">Kalem Rengi</label>
                <div class="color-input-wrapper">
                    <input
                        type="color"
                        v-model="localStrokeColor"
                        @input="updateField"
                        class="settings-color-input"
                    />
                    <input
                        type="text"
                        v-model="localStrokeColor"
                        @input="updateField"
                        class="settings-input color-text-input"
                        placeholder="#000000"
                    />
                </div>
            </div>

            <div class="settings-group">
                <label class="settings-label">Kalem Kalınlığı (px)</label>
                <div class="range-input-wrapper">
                    <input
                        type="range"
                        v-model.number="localStrokeWidth"
                        @input="updateField"
                        class="settings-range"
                        min="1"
                        max="10"
                        step="1"
                    />
                    <span class="range-value">{{ localStrokeWidth }}px</span>
                </div>
            </div>
        </div>

        <div class="settings-section">
            <h4 class="settings-section-title">Görünüm Ayarları</h4>

            <div class="settings-group">
                <label class="settings-label">Arkaplan Rengi</label>
                <div class="color-input-wrapper">
                    <input
                        type="color"
                        v-model="localBackgroundColor"
                        @input="updateField"
                        class="settings-color-input"
                    />
                    <input
                        type="text"
                        v-model="localBackgroundColor"
                        @input="updateField"
                        class="settings-input color-text-input"
                        placeholder="#ffffff"
                    />
                </div>
            </div>

            <div class="settings-group">
                <label class="settings-label">Kenarlık Rengi</label>
                <div class="color-input-wrapper">
                    <input
                        type="color"
                        v-model="localBorderColor"
                        @input="updateField"
                        class="settings-color-input"
                    />
                    <input
                        type="text"
                        v-model="localBorderColor"
                        @input="updateField"
                        class="settings-input color-text-input"
                        placeholder="#e5e7eb"
                    />
                </div>
            </div>

            <div class="settings-row">
                <div class="settings-group">
                    <label class="settings-label">Kenarlık Kalınlığı (px)</label>
                    <input
                        type="number"
                        v-model.number="localBorderWidth"
                        @input="updateField"
                        class="settings-input"
                        min="0"
                        max="10"
                        placeholder="1"
                    />
                </div>

                <div class="settings-group">
                    <label class="settings-label">Köşe Yuvarlaklığı (px)</label>
                    <input
                        type="number"
                        v-model.number="localBorderRadius"
                        @input="updateField"
                        class="settings-input"
                        min="0"
                        max="50"
                        placeholder="8"
                    />
                </div>
            </div>
        </div>

        <div class="settings-section">
            <h4 class="settings-section-title">Buton Ayarları</h4>

            <div class="settings-group">
                <div class="settings-checkbox-group">
                    <input
                        type="checkbox"
                        id="signature-show-clear"
                        v-model="localShowClearButton"
                        @change="updateField"
                        class="settings-checkbox"
                    />
                    <label for="signature-show-clear" class="settings-checkbox-label">
                        Temizle butonu göster
                    </label>
                </div>
            </div>

            <div v-if="localShowClearButton" class="settings-group">
                <label class="settings-label">Temizle Buton Metni</label>
                <input
                    type="text"
                    v-model="localClearButtonText"
                    @input="updateField"
                    class="settings-input"
                    placeholder="Temizle"
                    ref="clearButtonTextInput"
                />
            </div>
        </div>

        <div class="settings-section">
            <h4 class="settings-section-title">Placeholder Ayarları</h4>

            <div class="settings-group">
                <label class="settings-label">Placeholder Metni</label>
                <input
                    type="text"
                    v-model="localPlaceholder"
                    @input="updateField"
                    class="settings-input"
                    placeholder="Burada imza çizin"
                    ref="placeholderInput"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "SignatureSettings",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            localFieldLabel: "",
            localAlign: "top",
            localAltLabel: "",
            localIsRequired: false,
            localVisibility: true,
            localSlug: "",
            localCanvasWidth: 400,
            localCanvasHeight: 200,
            localStrokeColor: "#000000",
            localStrokeWidth: 2,
            localBackgroundColor: "#ffffff",
            localBorderColor: "#e5e7eb",
            localBorderWidth: 1,
            localBorderRadius: 8,
            localShowClearButton: true,
            localClearButtonText: "Temizle",
            localPlaceholder: "Burada imza çizin",
            updateTimer: null,
        };
    },
    created() {
        this.initializeData();
    },
    methods: {
        ...mapActions({
            updateFormField: "forms/updateFormField",
        }),

        initializeData() {
            if (this.item) {
                this.localFieldLabel = this.item.fieldLabel || "İmza";
                this.localAlign = this.item.align || "top";
                this.localAltLabel = this.item.altLabel || "Lütfen imzanızı çiziniz";
                this.localIsRequired = this.item.isRequired || false;
                this.localVisibility = this.item.visibility !== undefined ? this.item.visibility : true;
                this.localSlug = this.item.slug || "";
                this.localCanvasWidth = this.item.canvasWidth || 400;
                this.localCanvasHeight = this.item.canvasHeight || 200;
                this.localStrokeColor = this.item.strokeColor || "#000000";
                this.localStrokeWidth = this.item.strokeWidth || 2;
                this.localBackgroundColor = this.item.backgroundColor || "#ffffff";
                this.localBorderColor = this.item.borderColor || "#e5e7eb";
                this.localBorderWidth = this.item.borderWidth || 1;
                this.localBorderRadius = this.item.borderRadius || 8;
                this.localShowClearButton = this.item.showClearButton !== undefined ? this.item.showClearButton : true;
                this.localClearButtonText = this.item.clearButtonText || "Temizle";
                this.localPlaceholder = this.item.placeholder || "Burada imza çizin";
            }
        },

        setSlug(slug) {
            this.localSlug = this.sanitizeSlug(slug);
            this.updateField();
        },

        sanitizeSlug(slug) {
            if (!slug) return '';

            return slug
                .replace(/ğ/gim, "g")
                .replace(/ü/gim, "u")
                .replace(/ş/gim, "s")
                .replace(/ı/gim, "i")
                .replace(/ö/gim, "o")
                .replace(/ç/gim, "c")
                .replace(/[^a-z0-9-]/gim, "-")
                .replace(/-+/gim, "-")
                .replace(/^-|-$/gim, "")
                .toLowerCase();
        },

        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                self.$emit('update-field-label', self.localFieldLabel);
                self.$emit('update-align', self.localAlign);
                self.$emit('update-alt-label', self.localAltLabel);
                self.$emit('update-is-required', self.localIsRequired);
                self.$emit('update-canvas-width', self.localCanvasWidth);
                self.$emit('update-canvas-height', self.localCanvasHeight);
                self.$emit('update-stroke-color', self.localStrokeColor);
                self.$emit('update-stroke-width', self.localStrokeWidth);
                self.$emit('update-background-color', self.localBackgroundColor);
                self.$emit('update-border-color', self.localBorderColor);
                self.$emit('update-border-width', self.localBorderWidth);
                self.$emit('update-border-radius', self.localBorderRadius);
                self.$emit('update-show-clear-button', self.localShowClearButton);
                self.$emit('update-clear-button-text', self.localClearButtonText);
                self.$emit('update-placeholder', self.localPlaceholder);

                const updateFields = {
                    visibility: self.localVisibility,
                    slug: self.localSlug,
                    signature: {
                        fieldLabel: self.localFieldLabel,
                        align: self.localAlign,
                        altLabel: self.localAltLabel,
                        isRequired: self.localIsRequired,
                        canvasWidth: self.localCanvasWidth,
                        canvasHeight: self.localCanvasHeight,
                        strokeColor: self.localStrokeColor,
                        strokeWidth: self.localStrokeWidth,
                        backgroundColor: self.localBackgroundColor,
                        borderColor: self.localBorderColor,
                        borderWidth: self.localBorderWidth,
                        borderRadius: self.localBorderRadius,
                        showClearButton: self.localShowClearButton,
                        clearButtonText: self.localClearButtonText,
                        placeholder: self.localPlaceholder,
                    }
                };

                console.log('🔴 Signature settings updating:', {
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                    item: self.item
                });

                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                });
                console.log('🔴 Signature settings updateFormField called');
            }, 800);
        },
    },
    watch: {
        item: {
            deep: true,
            immediate: true,
            handler: function (val, oldVal) {
                if (!val) return;

                console.log('🔴 SignatureSettings item watcher:', {
                    val,
                    oldVal,
                    fieldLabel: val.fieldLabel,
                    align: val.align,
                    altLabel: val.altLabel,
                    placeholder: val.placeholder
                });

                const isInitialLoad = !oldVal || oldVal !== val;

                if (isInitialLoad) {
                    const fieldLabelInput = this.$refs.fieldLabelInput;
                    const altLabelInput = this.$refs.altLabelInput;
                    const clearButtonTextInput = this.$refs.clearButtonTextInput;
                    const placeholderInput = this.$refs.placeholderInput;

                    if (!fieldLabelInput || document.activeElement !== fieldLabelInput) {
                        this.localFieldLabel = val.fieldLabel || "İmza";
                    }

                    this.localAlign = val.align || "top";

                    if (!altLabelInput || document.activeElement !== altLabelInput) {
                        this.localAltLabel = val.altLabel || "Lütfen imzanızı çiziniz";
                    }

                    this.localIsRequired = val.isRequired || false;
                    this.localCanvasWidth = val.canvasWidth || 400;
                    this.localCanvasHeight = val.canvasHeight || 200;
                    this.localStrokeColor = val.strokeColor || "#000000";
                    this.localStrokeWidth = val.strokeWidth || 2;
                    this.localBackgroundColor = val.backgroundColor || "#ffffff";
                    this.localBorderColor = val.borderColor || "#e5e7eb";
                    this.localBorderWidth = val.borderWidth || 1;
                    this.localBorderRadius = val.borderRadius || 8;
                    this.localShowClearButton = val.showClearButton !== undefined ? val.showClearButton : true;

                    if (!clearButtonTextInput || document.activeElement !== clearButtonTextInput) {
                        this.localClearButtonText = val.clearButtonText || "Temizle";
                    }

                    if (!placeholderInput || document.activeElement !== placeholderInput) {
                        this.localPlaceholder = val.placeholder || "Burada imza çizin";
                    }

                    this.localVisibility = val.visibility !== undefined ? val.visibility : true;
                    
                    const slugInput = this.$refs.slugInput;
                    if (!slugInput || document.activeElement !== slugInput) {
                        this.localSlug = val.slug || "";
                    }

                    console.log('🔴 SignatureSettings watcher updated values:', {
                        localFieldLabel: this.localFieldLabel,
                        localAlign: this.localAlign,
                        localAltLabel: this.localAltLabel,
                        localPlaceholder: this.localPlaceholder
                    });
                }
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.signature-settings {
    padding: clamp(1rem, 2.5vw, 1.5rem);
    background: linear-gradient(145deg,
        rgba(255, 255, 255, 0.95) 0%,
        rgba(255, 255, 255, 0.85) 100%);
    border-radius: 0.75rem;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.settings-group {
    margin-bottom: clamp(1rem, 2.5vw, 1.5rem);

    &:last-child {
        margin-bottom: 0;
    }
}

.settings-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: clamp(0.75rem, 2vw, 1rem);

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 0.75rem;
    }
}

.settings-label {
    display: block;
    font-size: clamp(0.875rem, 1.8vw, 1rem);
    font-weight: 600;
    color: rgba(55, 65, 81, 0.9);
    margin-bottom: clamp(0.375rem, 1vw, 0.5rem);

    .settings-label-required {
        color: #ef4444;
        margin-left: 0.25rem;
    }
}

.settings-input {
    width: 100%;
    padding: clamp(0.75rem, 1.8vw, 1rem);
    font-size: clamp(0.875rem, 1.8vw, 1rem);
    color: rgba(55, 65, 81, 0.9);
    background: rgba(255, 255, 255, 0.8);
    border: 2px solid rgba(229, 231, 235, 0.8);
    border-radius: 0.5rem;
    transition: all 0.2s ease;

    &:focus {
        outline: none;
        border-color: #f26a52;
        background: rgba(255, 255, 255, 0.95);
        box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
    }

    &:hover {
        border-color: rgba(242, 106, 82, 0.5);
    }
}

.settings-select {
    @extend .settings-input;
    cursor: pointer;

    option {
        padding: 0.5rem;
    }
}

.color-input-wrapper {
    display: flex;
    gap: clamp(0.5rem, 1.2vw, 0.75rem);
    align-items: center;
}

.settings-color-input {
    width: 3rem;
    height: 3rem;
    padding: 0.25rem;
    border: 2px solid rgba(229, 231, 235, 0.8);
    border-radius: 0.5rem;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        border-color: #f26a52;
    }

    &:focus {
        outline: none;
        border-color: #f26a52;
        box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
    }
}

.color-text-input {
    flex: 1;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: clamp(0.8rem, 1.6vw, 0.9rem);
}

.range-input-wrapper {
    display: flex;
    align-items: center;
    gap: clamp(0.75rem, 1.8vw, 1rem);
}

.settings-range {
    flex: 1;
    height: 0.5rem;
    background: rgba(229, 231, 235, 0.8);
    border-radius: 0.25rem;
    outline: none;
    cursor: pointer;

    &::-webkit-slider-thumb {
        appearance: none;
        width: 1.25rem;
        height: 1.25rem;
        background: linear-gradient(135deg, #f26a52 0%, #e55a42 100%);
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
            transform: scale(1.1);
            box-shadow: 0 4px 12px rgba(242, 106, 82, 0.3);
        }
    }

    &::-moz-range-thumb {
        width: 1.25rem;
        height: 1.25rem;
        background: linear-gradient(135deg, #f26a52 0%, #e55a42 100%);
        border-radius: 50%;
        border: none;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
            transform: scale(1.1);
            box-shadow: 0 4px 12px rgba(242, 106, 82, 0.3);
        }
    }
}

.range-value {
    font-size: clamp(0.8rem, 1.6vw, 0.9rem);
    font-weight: 600;
    color: #f26a52;
    min-width: 2.5rem;
    text-align: center;
    background: rgba(242, 106, 82, 0.1);
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
}

.settings-checkbox-group {
    display: flex;
    align-items: center;
    gap: clamp(0.5rem, 1.2vw, 0.75rem);
}

.settings-checkbox {
    width: 1.25rem;
    height: 1.25rem;
    accent-color: #f26a52;
    cursor: pointer;

    &:focus {
        outline: 2px solid rgba(242, 106, 82, 0.3);
        outline-offset: 2px;
    }
}

.settings-checkbox-label {
    font-size: clamp(0.875rem, 1.8vw, 1rem);
    font-weight: 500;
    color: rgba(55, 65, 81, 0.9);
    cursor: pointer;
    margin: 0;

    &:hover {
        color: #f26a52;
    }
}

.settings-section {
    margin-top: clamp(1.5rem, 3vw, 2rem);
    margin-bottom: clamp(1rem, 2.5vw, 1.5rem);

    &:first-child {
        margin-top: 0;
    }

    &:last-child {
        margin-bottom: 0;
    }
}

.settings-section-title {
    font-size: clamp(1rem, 2vw, 1.125rem);
    font-weight: 700;
    color: rgba(31, 41, 55, 0.9);
    margin-bottom: clamp(0.75rem, 1.8vw, 1rem);
    padding-bottom: clamp(0.375rem, 1vw, 0.5rem);
    border-bottom: 2px solid rgba(242, 106, 82, 0.2);
}

@media (max-width: 768px) {
    .signature-settings {
        padding: 1rem;
    }

    .color-input-wrapper {
        flex-direction: column;
        align-items: stretch;
        gap: 0.5rem;
    }

    .settings-color-input {
        align-self: flex-start;
    }

    .range-input-wrapper {
        flex-direction: column;
        align-items: stretch;
        gap: 0.5rem;
    }

    .range-value {
        align-self: center;
    }
}

@media (max-width: 480px) {
    .signature-settings {
        padding: 0.75rem;
    }

    .settings-group {
        margin-bottom: 1rem;
    }

    .settings-section {
        margin-top: 1.25rem;
        margin-bottom: 1rem;
    }
}

.signature-settings {
    will-change: scroll-position;
}

.settings-input,
.settings-select,
.settings-color-input {
    will-change: border-color, box-shadow;
}

@media (prefers-reduced-motion: reduce) {
    .settings-input,
    .settings-select,
    .settings-color-input,
    .settings-range {
        transition: none;
    }

    .settings-range::-webkit-slider-thumb,
    .settings-range::-moz-range-thumb {
        transition: none;

        &:hover {
            transform: none;
        }
    }
}
</style>
